import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import styles from './DefaultPaymentForm.module.scss'

const cx = classnames.bind(styles);

const DefaultPaymentForm = function ({formId, data, sendPayment, className}) {
  const handleSubmit = function (e) {
    e.preventDefault();

    sendPayment({
      id: data.id,
      cardType: data.cardType,
      directPayment: data.directPayment,
    })
  }

  return (
    <form
      id={formId}
      className={cx('root', {empty: !data.text}, className)}
      onSubmit={handleSubmit}
    >
      {data.text && (
        <p className={cx('payment-description')}>{data.text}</p>
      )}
    </form>
  )
}

DefaultPaymentForm.propTypes = {
  formId: PropTypes.string.isRequired,
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    cardType: PropTypes.string.isRequired,
    directPayment: PropTypes.bool.isRequired,
  }).isRequired,
}

export default DefaultPaymentForm;
